import { createSelector } from 'reselect';

export const selectDepartmentsSlice = state => state.departments;

export const selectDepartments = createSelector(
  selectDepartmentsSlice,
  slice => slice.departments
);
export const departmentsLoaded = createSelector(
  selectDepartmentsSlice,
  slice => slice.departmentsLoaded
);
export const selectActiveDepartment = createSelector(
  selectDepartmentsSlice,
  slice => slice.activeDepartment
);

export const departmentsMeta = createSelector(
  selectDepartmentsSlice,
  slice => slice.meta
);
export const departmentsFilters = createSelector(
  selectDepartmentsSlice,
  slice => slice.filters
);

export const departmentCreating = createSelector(
  selectDepartmentsSlice,
  slice => slice.isCreating
);
export const departmentUpdating = createSelector(
  selectDepartmentsSlice,
  slice => slice.isUpdating
);
export const departmentDeleting = createSelector(
  selectDepartmentsSlice,
  slice => slice.isDeleting
);
export const departmentsErrors = createSelector(
  selectDepartmentsSlice,
  slice => slice.errors
);
